import { Directive, Inject, AfterViewInit } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwAutotip
 * @module mw.components.tooltip
 *
 * @description
 * `mw-autotip` is an attribute directive that will add an md-tooltip component if the inner text of the element has been truncated by CSS.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <div mw-autotip="true" style="width: 50px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Long text that might get truncated my CSS</div>
 * </hljs>
 *
 */
@Directive({
  selector: '[mwAutotip]'
})
export class AutotipDirective implements AfterViewInit {
    constructor(@Inject('$compile') private $compile: ng.ICompileService,
                @Inject('$element') private $element: ng.IRootElementService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    // every directive needs to implement this life cycle method
    ngAfterViewInit() {
        // Give the element a chance to render
        this.$timeout(() => {
            // Check a couple properties that would indicate/suggest CSS truncation is in place
            if (this.$element[0].offsetWidth < this.$element[0].scrollWidth) {
                // Check if we've already added the md-tooltip for this element, don't duplicate if we have
                if (this.$element[0].attributes['hastooltip'] === undefined) {
                    // Add attribute to avoid duplicate md-tooltips and digest explosions
                    this.$element.attr('hastooltip', 'true');
                    // Add the md-tooltip and compile
                    this.$element.append('<md-tooltip>' + this.$element[0].innerText + '</md-tooltip>');
                    this.$compile(this.$element)(this.$scope);
                }
            }
        }, 500);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/tooltip/autotip.tooltip.directive.ts